import { useQuery, useMutation } from '@tanstack/react-query';

import { WebhooksAPI } from '@newo/api/gateway';
import type {
    TIncomingWebhookCreateData,
    TIncomingWebhookUpdateData,
    TWebhookData
} from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const webhooksAPI = new WebhooksAPI(axios);

export const useWebhooksQuery = () =>
    useQuery({
        queryKey: ['webhooks'],
        queryFn: async () => webhooksAPI.getWebhooks()
    });

export const useWebhookCreateMutation = () =>
    useMutation({
        mutationFn: async (data: TWebhookData) =>
            webhooksAPI.createWebhook(data)
    });

export const useWebhookUpdateMutation = () =>
    useMutation({
        mutationFn: async ({
            webhookId,
            data
        }: {
            webhookId: string;
            data: TWebhookData;
        }) => webhooksAPI.updateWebhook(webhookId, data)
    });

export const useWebhookDeleteMutation = () =>
    useMutation({
        mutationFn: async ({ webhookId }: { webhookId: string }) =>
            webhooksAPI.deleteWebhook(webhookId)
    });

export const useIncomingWebhooksQuery = () =>
    useQuery({
        queryKey: ['webhooks/incoming'],
        queryFn: async () => webhooksAPI.getIncomingWebhooks()
    });

export const useIncomingWebhookCreateMutation = () =>
    useMutation({
        mutationFn: async (data: TIncomingWebhookCreateData) =>
            webhooksAPI.createIncomingWebhook(data)
    });

export const useIncomingWebhookUpdateMutation = () =>
    useMutation({
        mutationFn: async ({
            webhookId,
            data
        }: {
            webhookId: string;
            data: TIncomingWebhookUpdateData;
        }) => webhooksAPI.updateIncomingWebhook(webhookId, data)
    });

export const useIncomingWebhookDeleteMutation = () =>
    useMutation({
        mutationFn: async ({ webhookId }: { webhookId: string }) =>
            webhooksAPI.deleteIncomingWebhook(webhookId)
    });
